import styled from 'styled-components';

export const StyledStarRatingContainer = styled.div<{ showPointer: boolean }>`
    display: flex;
    justify-content: center;
    flex-direction: row;
    padding: 5px;
    cursor: ${(props) => (props.showPointer ? 'pointer' : 'unset')};
`;
